import React, { FC } from "react"
import LatestNews from "@components/LatestNews"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import parseContentImages, { ParseContentImagesProps } from "@utils/parseContentImages"

const StrapiLatestNews: FC<Queries.StrapiComponentSectionsLatestNews> = ({
    content,
    content_images: contentImages
}) => {
    const data = useStaticQuery(graphql`
        query {
            allStrapiNewsItem (
                skip: 0
                limit: 9
                sort: {fields: published_date, order: DESC}
            )  {
                nodes {
                    title
                    slug
                    categories {
                        title
                    }
                    published_date
                    thumbnail {
                        alternativeText
                        file {
                            childImageSharp {
                                gatsbyImageData (
                                    width: 370
                                    height: 224
                                )
                            }
                        }
                    }
                }
            }
        }
    `)

    return <LatestNews
        url="/nieuws/"
        content={parseContentImages(
            content,
            contentImages as unknown as ParseContentImagesProps[]
        )}
        newsItems={data.allStrapiNewsItem.nodes.map((item) => ({
            image: item?.thumbnail ? <GatsbyImage
                alt={item.thumbnail?.alternativeText}
                image={item.thumbnail.file?.childImageSharp?.gatsbyImageData}
            /> : undefined,
            slug: `/nieuws/${item.slug}/`,
            type: "news",
            title: item.title,
            category: item?.categories?.map((category) => category.title)?.join(" - "),
            date: item.published_date
        }))}
    />
}

export default StrapiLatestNews
